import React from 'react';
import createReactClass from 'create-react-class';
import Suggest from 'components/Suggest';
import { withRouter } from 'react-router-dom';

if (process.env.NODE_ENV !== 'test') {
  require('./TickerSearch.scss');
}

const TickerSearch = createReactClass({
  displayName: 'TickerSearch',

  getInitialState() {
    return {
      showSearch: false,
      windowWidth: window.innerWidth,
    };
  },

  handleSuggest(item) {
    const { windowWidth } = this.state;
    const isMobile = windowWidth < 767;
    const { ITEM, SECTOR } = item;
    const itemSector = encodeURIComponent(`${ITEM}.${SECTOR}`);
    if (isMobile) {
      window.scrollTo({ top: 720, behavior: 'smooth' });
    }
    this.props.history.push(`/instrument/${itemSector}`);
  },

  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  },

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  handleToggle() {
    this.setState({ showSearch: !this.state.showSearch });
  },

  render() {
    const { windowWidth } = this.state;

    const isMobile = windowWidth < 767;

    return (
      <div>
        {isMobile ? (
          [
            <button className="toggle-search" onClick={this.handleToggle}>
              Søk
            </button>,
            this.state.showSearch ? (
              <div className="TickerSearch">
                <form role="search" name="TickerSearch">
                  <label htmlFor="TickerSearch">Søk ticker/selskap</label>
                  <Suggest
                    innerRef={this.Instrument}
                    id="TickerSearch"
                    placeholder="Ticker/selskap"
                    onSelect={this.handleSuggest}
                  />
                </form>
              </div>
            ) : null,
          ]
        ) : (
          <div className="TickerSearch">
            <form role="search" name="TickerSearch">
              <label htmlFor="TickerSearch">Søk ticker/selskap</label>
              <Suggest
                innerRef={this.Instrument}
                id="TickerSearch"
                placeholder="Ticker/selskap"
                onSelect={this.handleSuggest}
              />
            </form>
          </div>
        )}
      </div>
    );
  },
});
export default withRouter(TickerSearch);
